import { createStyles } from '@affstore-ds/uikit'

export const useAdvertiserLogoStyles = createStyles(() => ({
  root: {},
}))
